// client/src/pages/GalleryDownloadPage.js
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import PageWrapper from '../components/PageWrapper';
import '../styles/GalleryDownloadPage.css';

// Icône SVG inline
const IconDownload = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

const GalleryDownloadPage = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [downloadStarted, setDownloadStarted] = useState(false);
  
  useEffect(() => {
    const initiateDownload = async () => {
      try {
        setLoading(true);
        
        // Télécharger l'image directement
        window.location.href = `/api/gallery/download/${token}`;
        
        // Marquer le téléchargement comme démarré
        setDownloadStarted(true);
        setLoading(false);
      } catch (err) {
        console.error('Erreur lors du téléchargement:', err);
        setError('Le lien de téléchargement est invalide ou a expiré');
        setLoading(false);
      }
    };
    
    // Démarrer le téléchargement après un court délai
    const timer = setTimeout(() => {
      initiateDownload();
    }, 1000);
    
    return () => clearTimeout(timer);
  }, [token]);
  
  return (
    <PageWrapper pageType="download">
      <div className="download-page">
        <div className="download-container">
          <h1>Téléchargement d'Image</h1>
          
          {loading ? (
            <div className="download-loading">
              <div className="loading-spinner"></div>
              <p>Préparation de votre téléchargement...</p>
            </div>
          ) : error ? (
            <div className="download-error">
              <div className="error-icon">!</div>
              <h2>Téléchargement impossible</h2>
              <p>{error}</p>
              <p>
                Le lien de téléchargement a peut-être expiré ou est invalide. 
                Veuillez effectuer une nouvelle demande de téléchargement.
              </p>
              <div className="download-actions">
                <Link to="/galeries" className="back-link">
                  Retour aux galeries
                </Link>
              </div>
            </div>
          ) : (
            <div className="download-success">
              <div className="success-icon">
                <IconDownload />
              </div>
              <h2>Téléchargement en cours</h2>
              <p>
                Votre téléchargement devrait démarrer automatiquement.
                Si ce n'est pas le cas, cliquez sur le bouton ci-dessous pour réessayer.
              </p>
              <div className="download-actions">
                <a href={`/api/gallery/download/${token}`} className="download-button">
                  Télécharger à nouveau
                </a>
                <Link to="/galeries" className="back-link">
                  Retour aux galeries
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </PageWrapper>
  );
};

export default GalleryDownloadPage;